import { useState } from 'react'
import { Box, Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { headerMenuStyles as styles } from 'src/components/Layout/components/Header/components/HeaderMenu/HeaderMenuStyles'
import IniciadoresMenu from 'src/components/Layout/components/Header/components/HeaderMenu/components/IniciadoresMenu'
import { menuStyles } from 'src/components/shared/styles/MenuStyles'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import Link from 'src/components/shared/ui/Link'
import { EscritoFormInitialValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { ESCRITOS_LEXNET } from 'src/constants/routes'
import { useEscritoContext } from 'src/contexts/EscritoContext/EscritoContext'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { TipoMensaje, TipoMensajeURLPath } from 'src/enums/EscritosLegales'
import { FormField } from 'src/enums/Form'

export default function HeaderMenu(): JSX.Element {
  const { t } = useTranslation()
  const { tipoMensaje, changeTipoMensaje } = useTipoMensajeContext()
  const { setInitialValues, setEscrito } = useEscritoContext()
  const { lexnetUserText } = useLexnetStatusContext()

  const [anchorEl, setAnchorEl] = useState(null)
  const openMenu = Boolean(anchorEl)

  function menuHandleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function menuHandleClose(tipoMensaje: TipoMensaje) {
    setInitialValues({
      ...EscritoFormInitialValues,
      [FormField.REMITENTE_TITULAR]: lexnetUserText()
    })
    setEscrito(null)
    changeTipoMensaje(tipoMensaje)
    setAnchorEl(null)
  }

  return (
    <Box>
      <Box onClick={menuHandleClick}>
        <ButtonPrimaryOutlined
          sx={styles.headerMenuButton}
          onClick={() => {
            return null
          }}
        >
          {t('navigation.escritos')}
        </ButtonPrimaryOutlined>
      </Box>
      <Menu
        id="menu"
        sx={menuStyles.menu}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={openMenu}
        onClose={() => menuHandleClose(tipoMensaje)}
      >
        <Link to={ESCRITOS_LEXNET(TipoMensajeURLPath.TRAMITE)}>
          <MenuItem sx={menuStyles.menuItem} onClick={() => menuHandleClose(TipoMensaje.ESCRITO)}>
            {t('navigation.tramite')}
            {/* <AngleRightIcon /> */}
          </MenuItem>
        </Link>
        {/* <Link to={ESCRITOS_LEXNET(TipoMensajeURLPath.MONITORIO)}>
          <MenuItem sx={menuStyles.menuItem} onClick={() => menuHandleClose(TipoMensaje.MONITORIO)}>
            {t('navigation.monitorio')}
          </MenuItem>
        </Link> */}
        <IniciadoresMenu handleClose={menuHandleClose} />
        <Link to={ESCRITOS_LEXNET(TipoMensajeURLPath.PERSONACION)}>
          <MenuItem
            sx={menuStyles.menuItem}
            onClick={() => menuHandleClose(TipoMensaje.PERSONACION)}
          >
            {t('navigation.personacion')}
            {/* <AngleRightIcon /> */}
          </MenuItem>
        </Link>
      </Menu>
    </Box>
  )
}
